<template>
  <div class="in-stock__list">
    <slot name="products" :view="view" :moduleCatalog="moduleCatalog"></slot>
    <product-card v-for="item in moduleCatalog.products" :info="item" :key="item.ID">
      <template v-slot:product="productSlotProps">
        <a :href="productSlotProps.info.DETAIL_PAGE_URL">
          <div class="in-stock-card__img">
            <picture v-if="productSlotProps.info.PICTURE">
              <source :srcset="productSlotProps.info.PICTURE_WEBP ? productSlotProps.info.PICTURE_WEBP : ''" type="image/webp">
              <img :src="productSlotProps.info.PICTURE ? productSlotProps.info.PICTURE : ''" :alt="productSlotProps.info.IMG_DESCRIPTION" loading="lazy">
            </picture>

            <img v-else src="/local/templates/xpage/img/catalog/product.svg" alt="Заглушка товара" loading="lazy">
          </div>
        </a>
        <div class="in-stock-card__content">
          <div class="in-stock-card__top">
            <p class="in-stock-card__size">{{ productSlotProps.info.SIZE }}</p>
            <a :href="productSlotProps.info.DETAIL_PAGE_URL">
              <p class="in-stock-card__title text-running" data-speed="1">
                <span>{{ productSlotProps.info.NAME }}</span>
              </p>
            </a>
            <p class="in-stock-card__desc">{{ productSlotProps.info.NUMBER }}</p>
            <p class="in-stock-card__stock">
              <span class="label">В наличии</span>
              <span class="text">{{ productSlotProps.info.AV_QUANTITY }} шт.</span>
            </p>
          </div>

          <add-to-cart
              :product-id='Number(item.ID)'
              :min-quantity='Number(productSlotProps.info.AMOUNT)'
              :max-quantity='Number(productSlotProps.info.AV_QUANTITY)'
              :step-quantity=5
              :params='formatParams(item.LENGTH, item.HEIGHT, item.WIDTH)'
          ></add-to-cart>
        </div>
      </template>
    </product-card>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import ProductCard from "./ProductCard.vue";
import AddToCart from "@/components/cart/AddToCart.vue";

export default {
  name: "ProductListStock",
  components: {ProductCard, AddToCart},
  props: {
    pages: Number,
    view: Number,
    sort: Number,
    sort_by: String,
    sort_order: String,
    section: Number,
    count: Number,
    nav_num: Number,
    filter: [Array, Object],
    items: Array,
  },
  data() {
    return {
      page: 2,
      all: false,
      itemQuantity: 0
    };
  },
  computed: {
    ...mapState([
      "moduleCatalog"
    ])
  },
  methods: {
    ...mapActions([
      "SET_PRODUCTS"
    ]),
    loadMore() {
      if (this.all) return;
      let query = (document.location.search === "" ? "?" : "&") + "pagination=Y&PAGEN_" + this.nav_num + "=" + this.page;
      fetch(document.location.href + query, {
        method: "GET"
      })
          .then(response => response.json())
          .then(result => {
            if (result.data.length > 0) {
              this.SET_PRODUCTS(result.data);
            }
            this.page++;
            if (this.pages < this.page) {
              this.all = true;
            }
          });
    },
    formatParams(length, height, width) {
      return {
        'length': length,
        'height': height,
        'width': width,
      };
    },
  },
  created() {
    this.all = this.pages < this.page;
  }
};
</script>